import { CountDown, eventTypeValidate } from '../../utils/dateFnsUtils';

/**
 * useContent like hook effect
 *
 * @export
 */
export function useContent(content) {
    const { title, flights, contentType, entitlementTypes, sport, live  } = content ?? {};
    const [{ flights: arrayFlightsStartEnd }] = flights ?? [{}];
    const [{  start: startFlight, end  }] = arrayFlightsStartEnd ?? [{}];
    const eventType = arrayFlightsStartEnd ? eventTypeValidate(arrayFlightsStartEnd, live) : '';
    const { days, hours, minutes, seconds } = !!arrayFlightsStartEnd ? CountDown(arrayFlightsStartEnd) : {};
    return {
        title, 
        flights, 
        contentType, 
        entitlementTypes, 
        sport, 
        live,
        arrayFlightsStartEnd,
        startFlight,
        end,
        eventType,
        days, 
        hours, 
        minutes, 
        seconds
    } 
}